
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "32px",
    "height": "32px",
    "viewBox": "0 0 32 32",
    "enable-background": "new 0 0 32 32",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "_x3C_切片_x3E__6_",
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#999999",
        "d": "M25.988,23.702c-0.019-1.608-0.543-3.543-1.413-5.195c-0.77-1.462-1.72-2.562-2.767-3.203\n\tc0.998-0.897,1.584-2.195,1.584-3.537C23.393,9.14,21.244,7,18.602,7c-0.133,0-0.243,0.108-0.243,0.243v0.794\n\tc0,0.134,0.11,0.24,0.243,0.24c1.933,0,3.505,1.567,3.505,3.489c0,1.269-0.692,2.438-1.81,3.05l-0.206,0.115\n\tc-0.076,0.043-0.124,0.123-0.124,0.211l-0.001,0.598c0,0.105,0.068,0.199,0.169,0.229l0.282,0.09\n\tc2.373,0.736,4.286,4.824,4.286,7.72c0,0.132,0.108,0.239,0.243,0.239h0.799c0.004,0,0.009-0.001,0.013,0\n\tc0.133,0,0.242-0.107,0.242-0.239C26,23.752,25.994,23.726,25.988,23.702z M20.193,19.207c-0.833-1.555-1.879-2.714-3.016-3.379\n\tc1.062-0.925,1.747-2.267,1.747-3.779C18.925,9.266,16.648,7,13.851,7s-5.075,2.266-5.075,5.049c0,1.513,0.686,2.854,1.747,3.779\n\tc-1.135,0.664-2.183,1.824-3.017,3.379C6.563,20.967,6,23.043,6,24.759C6,24.892,6.109,25,6.242,25h0.799\n\tc0.134,0,0.242-0.108,0.242-0.241c0-1.519,0.508-3.37,1.358-4.949c0.882-1.646,1.991-2.759,3.136-3.164\n\tc0.635,0.285,1.333,0.452,2.073,0.452c0.739,0,1.438-0.167,2.073-0.452c1.146,0.406,2.255,1.518,3.137,3.162\n\tc0.851,1.585,1.356,3.437,1.356,4.951c0,0.133,0.109,0.241,0.244,0.241h0.798c0.003,0,0.009-0.001,0.013,0\n\tc0.133,0,0.242-0.108,0.242-0.241c0-0.026-0.006-0.053-0.012-0.075C21.685,22.983,21.123,20.942,20.193,19.207z M13.851,15.821\n\tc-2.09,0-3.79-1.692-3.79-3.772c0-2.078,1.7-3.771,3.79-3.771c2.091,0,3.79,1.693,3.79,3.771\n\tC17.641,14.129,15.941,15.821,13.851,15.821z"
      }
    }
  ]
})
    }
  